export default __webpack_public_path__ + "static/media/img12.50a7ba3e.jpg";